//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotifyMixin from 'src/mixins/Notification.js'
import {processOptions} from './utils.js'

export default{
  name: 'AddNovel',
  mixins: [NotifyMixin],
  data () {
    return {
      loading:false,
      processOptions,
      authorOptions:[],
      tagOptions:[],
      form: {
        url:'',
        name:'',
        cover:'',
        author:{"value":'',"label":''},
        desc:'',
        info:'',
        wordCount:'',
        tag:[],
        publish_datetime:'',
        plat:'',
        process:'',
        novelId:'',
        rate:3,
        myProcess:"1",
        readCount:0
      },
      initialForm: {
        url:'',
        name:'',
        cover:'',
        author:{"value":'',"label":''},
        desc:'',
        info:'',
        wordCount:'',
        tag:[],
        publish_datetime:'',
        plat:'',
        process:'',
        novelId:'',
        rate:3
      },
    }
  },

  created () {
    this.requestData()
  },

  methods: {
    async requestData() {
      try {
        const response1 = await this.$axios.get(`/api/novel/vas/authorList`);
        this.authorOptions = response1.data.data
        const response2 = await this.$axios.get(`/api/novel/tags/tagList`);
        this.tagOptions = response2.data.data
      } catch (error ) {
        if (error.response) {
          this.showErrNotif(error.response.data.error || `${error.response.status} ${error.response.statusText}`)
        } else {
          this.showErrNotif(error.message || error)
        }
      }
    },

    async spider() {
      try {
        this.loading = true
        const response = await this.$axios.post(`/api/novel/work/spider/`,{url:this.form.url});
        if (response.data.code == 2000){
          Object.keys(response.data.data).forEach(key => {
            switch(key){
              case 'author': 
                this.form[key].value = response.data.data[key].id
                this.form[key].label = response.data.data[key].name
                break
              default:
                this.form[key] = response.data.data[key]
            }
            
        });
        }else{
          this.showErrNotif(response.data.msg)
        }
      } catch (error ) {
        if (error.response) {
          this.showErrNotif(error.response.data.error || `${error.response.status} ${error.response.statusText}`)
        } else {
          this.showErrNotif(error.message || error)
        }
      }
      this.loading = false
    },

    async onSubmit() {
      let data = {}
      Object.keys(this.form).forEach(key => {
            switch(key){
              case 'author': 
                data[key] = this.form[key].value
                break
              case 'tag': 
                data[key] = this.form[key].map(item => item.value)
                break
              default:
                data[key] = this.form[key]
            }
            
       });
      const response = await this.$axios.post(`/api/novel/work/`,{...data});
      this.onReset()
    },

    onReset() {
      this.form = { ...this.initialForm };
    },


  }
}
